import { Controller } from "stimulus";

export default class FilterCount extends Controller {
	static targets = ["counter"];

	public declare counterTarget: HTMLElement;

	refresh() {
		const count = Array.from(
			this.element.querySelectorAll("input[type=checkbox]")
		).filter((c: HTMLInputElement) => c.checked).length;
		if (count == 0) {
			this.counterTarget.innerHTML = "";
		} else {
			this.counterTarget.innerHTML = "(" + count + ")";
		}
	}
}
